module.exports = __webpack_public_path__ + "static/img/brees-2019-slide-8.13ee41b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2019-slide-8.jpg
// module id = ye6A
// module chunks = 1